export const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
